<template>
<span style="display: none;">
</span>
</template>

<script>
import { Points, PlaneBufferGeometry, ShaderMaterial, Color, DoubleSide, Vector2 } from 'three'

const sharedGeometry = new PlaneBufferGeometry(1000, 1000, 256, 256)
const sharedMaterial = new ShaderMaterial({
  side: DoubleSide,
  transparent: true,
  vertexShader: `
    #include <common>

    varying vec2 vUv;
    varying vec3 vPos;
    varying vec3 vColor;

    uniform float time;
    void main(){
      vUv = uv;
      vec3 nPos = position;
      nPos.z += sin(time * 1.0 + nPos.x * 0.2) * 10.0;
      nPos.z += sin(time * 1.0 + nPos.y * 0.2) * 10.0;
      vPos = nPos;

      vColor = nPos;

      gl_Position = projectionMatrix * modelViewMatrix * vec4( nPos, 1.0 );
      gl_PointSize = 15.0;
    }
  `,
  fragmentShader: `
    varying vec2 vUv;
    varying vec3 vPos;
    varying vec3 vColor;

    uniform vec3 playerColor;
    uniform float time;
    uniform vec2 resolution;

    void main (void) {
      if (length(gl_PointCoord.xy) > 0.5) {
        discard;
      } else {
        gl_FragColor = vec4(vUv.xxy, 0.7);
      }
    }
  `
})
let resolution = new Vector2(window.innerWidth, window.innerHeight)
window.addEventListener('resize', () => {
  resolution.x = window.innerWidth
  resolution.y = window.innerHeight
})

export default {
  props: {
    visible: {
      default: true
    }
    // brick: {
    //   required: true
    // }
  },
  data () {
    return {
      renderable: false,
      uniforms: {
        time: {
          value: 0
        },
        resolution: {
          value: resolution
        },
        playerColor: {
          value: new Color('#ff0000')
        }
      }
    }
  },
  watch: {
    visible () {
      if (this.renderable) {
        this.renderable.visible = this.visible
      }
    }
  },
  mounted () {
    let mat = sharedMaterial.clone()
    mat.uniforms = this.uniforms
    let uniforms = mat.uniforms

    this.$emit('add-exec', () => {
      // uniforms.clicked.value = this.brick.clicked
      // uniforms.playerColor.value.set(this.brick.color)

      uniforms.time.value = window.performance.now() * 0.001
      mat.needsUpdate = true
    })
    this.renderable = new Points(sharedGeometry, mat)
    this.renderable.visible = this.visible
    this.$emit('element', this.renderable)
    this.$parent.$emit('add', this.renderable)
  },
  beforeDestroy () {
    this.$parent.$emit('remove', this.renderable)
  }
}
</script>

<style>

</style>
